<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasAnalitPerm.value" :to="{name: 'dashboard-analitico'}">Analítico Status</v-btn>
            <v-btn v-if="hasExempPerm.value" :to="{name: 'dashboard-exemplos'}">Exemplos</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasAnalitPerm = ref(false)
const hasExempPerm = ref(false)
const router = useRouter();
hasAnalitPerm.value = computed(() => router.resolve({name: 'dashboard-analitico'}).meta.has_perm())
hasExempPerm.value = computed(() => router.resolve({name: 'dashboard-exemplos'}).meta.has_perm())
</script>